import { defineSong } from '../types';

export default defineSong({
  id: 'aksam-cayi',
  title: 'Akşam Çayı',
  level: 2,
  key: 'D',
  bpm: 132,
  beats: 3,
  pattern: 'D-DUDU',
  style: 'Vals',
  desc: 'Üç vuruşluk bir vals. vi akorunun hüznünü yakala.',
  sections: [
    { name: 'Giriş', bars: ['D', 'D', 'G', 'A'] },
    { name: 'Kıta', bars: ['D', 'Bm', 'G', 'A', 'D', 'Bm', 'G', 'A'] },
    { name: 'Nakarat', bars: ['G', 'A', 'D', 'Bm', 'G', 'A', 'D', 'D'] },
  ],
  // Original lyrics written for kulaktan.com; each word with its length in beats.
  lyrics: [
    { bar: 5, text: 'Balkonda:3 ince:1 belli:2' },
    { bar: 7, text: 'Demli:2 bir:1 çay:1 buğusu:2' },
    { bar: 9, text: 'Gün:1 yavaşça:2 çekilir:3' },
    { bar: 11, text: 'Vapurun:3 düdüğüyle:3' },
    { bar: 13, text: 'Akşam:2 olur,:1 çay:1 demlenir:2' },
    { bar: 15, text: 'Sohbet:2 uzar,:1 yıldız:1 döner:2' },
    { bar: 17, text: 'Bir:1 bardak:2 daha:1 koy:2' },
    { bar: 19, text: 'Gece:2 bizimle:2 kalsın:2' },
  ],
});
